<template>
	<div class="dynamic-chart" ref="chartContainer">
		<!-- Dynamic Content Goes here -->
	</div>
</template>

<script>
	import { getChartData } from '@/helpers/content.js';
	// import InstagramYearly from '@/viz/instagram/InstagramYearly';
	// import InstagramDomain from '@/viz/instagram/InstagramDomain';
	// import InstagramDetailed from '@/viz/instagram/InstagramDetailed';

	export default {
		props: {
			chart: {
				type: String,
                required: true
			}
		},
		data() {
			return {
				height: 0,
				width: 0,
				// chartLib: {
				// 	instagram_yearly: InstagramYearly,
				// 	instagram_domain: InstagramDomain,
				// 	instagram_detailed: InstagramDetailed,
                // },
			}
		},
		computed: {
			chartData() {
				return getChartData(this.chart);
			}
		},
		mounted() {
			this.draw();

			window.onresize = () => {
				this.draw();
			};
		},
		methods: {
			dimensions(chartContainer) {
				if (!chartContainer) return;

				this.height = chartContainer.clientHeight;
				this.width = chartContainer.clientWidth;
			},
			draw() {
				const { chartContainer } = this.$refs;
				if (!chartContainer) return;

				this.dimensions(chartContainer);
				this.drawChart(chartContainer);
			},
			drawChart(chartContainer) {
				if (!chartContainer) return;
				if(!this.chartLib[this.chart]) return;

				chartContainer.innerHTML = '';
				this.chartObj = new this.chartLib[this.chart]({
					container: chartContainer,
					width: this.width,
					height: this.height,
					data: this.chartData,
				});
				this.chartObj.draw();
			}
		}
	};
</script>

<style lang="scss" scoped>
	.dynamic-chart {
		height: 100%;
		display: flex;
	}
</style>

<style lang="scss">
	// @import '../../design-system/sass/partials/chart.scss';
</style>